import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Reveal, MaskLines } from "./motion";

export const Waitlist = () => {
  const [email, setEmail] = useState("");

  const submit = async (e) => {
    e.preventDefault();

    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      toast.error("Ingresa un correo válido.");
      return;
    }

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: "Solicitud de acceso Aurexis",
          email,
          subject: "Nueva solicitud de acceso Aurexis",
          message:
            "Solicitud enviada desde el formulario de acceso privado de aurexis.capital.",
        }),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(
          data.detail || "No fue posible enviar la solicitud."
        );
      }

      toast.success("¡Gracias! Te avisaremos cuando tu acceso esté listo.");
      setEmail("");
    } catch (error) {
      toast.error(
        error.message || "No fue posible enviar la solicitud."
      );
    }
  };

  return (
    <section
      id="acceso"
      data-testid="acceso-section"
      className="flex min-h-screen items-center px-6 pb-24 pt-28 md:px-12"
    >
      <div className="mx-auto max-w-4xl text-center">
        <Reveal>
          <span className="font-accent text-xs uppercase tracking-[0.25em] text-gold">
            Acceso privado
          </span>
        </Reveal>
        <h2 className="mt-6 font-display text-5xl font-light leading-[0.95] tracking-tight text-ink md:text-7xl">
          <MaskLines lines={["Solicita tu acceso", "a Aurexis."]} />
        </h2>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-6 max-w-xl font-body text-base leading-relaxed text-ink-soft md:text-lg">
            Únete a la lista de espera.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <form
            onSubmit={submit}
            data-testid="waitlist-form"
            className="mx-auto mt-10 flex max-w-md flex-col gap-3 sm:flex-row"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              data-testid="waitlist-email-input"
              className="flex-1 rounded-full border border-ink/15 bg-surface px-6 py-4 font-body text-sm text-ink outline-none transition-colors duration-300 placeholder:text-ink-soft/60 focus:border-gold"
            />
            <button
              type="submit"
              data-testid="waitlist-submit-button"
              className="flex items-center justify-center gap-2 rounded-full bg-gold px-8 py-4 font-accent text-sm text-white transition-all duration-300 hover:bg-gold-light active:scale-[0.98]"
            >
              Solicitar acceso
              <ArrowRight className="h-4 w-4" />
            </button>
          </form>
        </Reveal>

        <Reveal delay={0.2}>
          <p
            data-testid="risk-disclaimer"
            className="mx-auto mt-14 max-w-2xl font-body text-xs leading-relaxed text-ink-soft"
          >
            Aviso: los activos virtuales no son moneda de curso legal en México y
            no están respaldados por el Gobierno Federal ni por el Banco de
            México. Operar con activos virtuales implica riesgos, incluyendo la
            posible pérdida total del valor. Este contenido es informativo y no
            constituye asesoría financiera.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
